export default __webpack_public_path__ + "static/media/cp_geo_cd.4d75b378.svg";